let messages;

const TEXT = 0,
  CHECK = 1,
  OPTIONS = 2,
  LIST_TYPE = 3;
// FILE = 4;

export const MESSAGE_TYPE_OOS = 1,
  MESSAGE_TYPE_INTERCONNECTED = 2,
  MESSAGE_TYPE_REJECT = 3;

export const INSPECTION_STATUS_NOT_USED = 5;
export const INSPECTION_STATUS_OUTOFSERVICE = 6;
export const INSPECTION_STATUS_COMPLETE = 2;

/**
 * Traverse top level check and if first level check is checkbox, then all
 * subitems except for list type need to be checked. This is because a step
 * is not complete if can be opened/expended and has leaves which have not
 * been filled with values.
 *
 * @param originalInspection
 * @param type
 * @returns {Array}
 */
export function validate(originalInspection, type) {
  messages = [];

  originalInspection.checks.forEach(function (step, index) {
    if (+step.type === CHECK) {
      /*
       * Note use of "every" function which  tests whether
       * all elements in the array pass the test implemented
       * by the provided function.
       *
       * For more information on this function see
       * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/every
       * */

      step.success = getValueObject(step).children.every(function (subStep) {
        if (stepIsOptional(subStep)) {
          return true;
        }
        if (subStep.disabled) {
          return true;
        }
        return isStepSuccessful(subStep);
      });
    } else if (+step.type === OPTIONS) {
      /* WARNING: For OPTIONS, logic is same as for checkbox if TOP
       * CHECK value is A (Applicable). Must change in both places!
       * TODO: consider refactoring here. */
      let valobj = getValueObject(step);
      if (valobj != null) {
        /* There is a special case for A == "Step is Applicable".
         * Why is special case?
         *
         * If we have anything else, we should check is any sub step
         * filled for example if we have only one comment.
         *
         * TODO: In future it may be better to have CD (Check)
         * option which says "is optional" or "is required" instead
         * of relying on hard-coded values. For now, any option
         * marked "A" will be treated this way, so CD must be
         * created uniformly, and with this in mind. */

        if ("" + valobj.valueName === "A") {
          /*
           * Note use of "every" function which  tests whether
           * all elements in the array pass the test implemented
           * by the provided function.
           *
           * For more information on this function see
           * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/every
           * */

          step.success = valobj.children.every(function (subStep) {
            if (stepIsOptional(subStep)) {
              return true;
            }
            return isStepSuccessful(subStep);
          });
        } else {
          step.success = isStepSuccessful(step);
        }
      }
    } else {
      step.success = isStepSuccessful(step);
    }
  });

  iterateCompleteBranch(originalInspection.checks, function (step, value) {
    if (
      !(step.handled && value.critical) &&
      (type === "daily" ||
        type === "weekly" ||
        originalInspection.allowReject) &&
      step.value &&
      value.critical
    ) {
      messages.push({
        type: originalInspection.allowReject
          ? MESSAGE_TYPE_REJECT
          : MESSAGE_TYPE_OOS,
        title:
          value && value.comment
            ? value.comment
            : step.comment
            ? step.comment
            : step.title,
      });
    }
  });

  return messages;

  function stepIsOptional(step) {
    /* Fields are always required, unless meta data says it should be
     * optional.  WARNING: this logic is also duplicated on server side
     * See Check::isRequired() and similar functions. */
    return (
      +step.type === LIST_TYPE || (step.metadata && step.metadata.optional)
    );
  }

  /**
   * Step is successful if any of the leaves on the branch has value
   * @param step
   * @returns {boolean}
   */
  function isStepSuccessful(step) {
    let success = false;

    iterateActiveLeaves([step], function (check) {
      success =
        success ||
        isCheckActive(check.value) ||
        (Array.isArray(check.values) && check.values.length > 0);
    });
    return success;
  }
}

/* Determine whether it is allowed to move to the next step in the inspection. E.g. is
    /* "Satisfactory" enabled? */

export function subEquipmentStepCanProceed(step) {
  let is_complete = true;

  if (step.interconnected) {
    step.interconnected.forEach(function (item) {
      /* If inspection is not used or out of service, return true - OK to move on. */
      if (
        +item.status === INSPECTION_STATUS_NOT_USED ||
        +item.status === INSPECTION_STATUS_OUTOFSERVICE ||
        /* If the equipment was marked OOS on a monthly due to
         * missed inspection (not a comment), you would not see an
         * inspection record and inspection status might be -1. */
        item.out_of_service === true
      ) {
        return;
      }

      /* NOTE: This step can be complete even though the entire inspection is not
                /* complete, so we can't just check for INSPECTION_STATUS_COMPLETE. */

      /* As long as something has been filled out for the corresponding Check, we're good
                /* to proceed. Note that the value doesn't have to be successful (S) - can also be a
                /* comment (C) or a true value.
                 *
                 * If the step has not been completed, you will get a null from
                 * the API. It may be possible to get a blank string as well.
                 * Make matches explicit to avoid false positives on values of
                 * 0.  */

      if (item.check_value === "" || item.check_value === null) {
        is_complete = false;
        return;
      }
    });
  }
  return is_complete;
}

export function isCheckActive(checkValue) {
  return checkValue && !(Array.isArray(checkValue) && checkValue.length === 0);
}

/**
 * Check if this step has some values which are unchangeable
 * and if yes than set them to the lock state.
 * @param originalInspection Inspection object with all steps
 * @param index Exact step that needs to be checked (one that is submited)
 */
export function lock(originalInspection, index) {
  let oneStep = [originalInspection.checks[index]];

  iterateCompleteBranch(oneStep, function (check, value) {
    /* Handle LIST_TYPE (free-form comments). Comments are always
     * locked (e.g. user cannot delete) when user moves to the next
     * step. Users have been instructed that once you move from the
     * step, you cannot change values.
     * */
    if (+check.type === LIST_TYPE && Array.isArray(check.value)) {
      check.value.forEach(function (item) {
        item.locked = true;
        originalInspection.checks[index].locked = true;
      });
    }

    if (check.value && value.locksValue) {
      check.locked = true;
      originalInspection.checks[index].locked = true;
    }
  });
}

/**
 * "Active" in the method name means that leave has selected values to the root
 * @param steps
 * @param cb
 */
export function iterateActiveLeaves(steps, cb, parent) {
  steps.forEach(function (step) {
    let valObj = getValueObject(step);

    if (!valObj) return;

    step.parent = parent;

    if (
      isCheckActive(step.value) ||
      (Array.isArray(step.values) && step.values.length)
    ) {
      if (isLeaf(valObj)) {
        cb(step, valObj);
      } else {
        iterateActiveLeaves((valObj && valObj.children) || [], cb, {
          check: step,
          value: valObj,
        });
      }
    }
  });

  function isLeaf(valObj) {
    return !(valObj && valObj.children && valObj.children.length);
  }
}

export function iterateCompleteBranch(steps, cb, parent) {
  steps.forEach(function (step) {
    let valObj = getValueObject(step);

    if (!valObj) return;

    step.parent = parent;

    if (isCheckActive(step.value)) {
      if (isLeaf(valObj)) {
        cb(step, valObj);
        while (step.parent) {
          cb(step.parent.check, step.parent.value);
          step = step.parent.check;
        }
      } else {
        iterateCompleteBranch((valObj && valObj.children) || [], cb, {
          check: step,
          value: valObj,
        });
      }
    }
  });

  function isLeaf(valObj) {
    return !(valObj && valObj.children && valObj.children.length);
  }
}

export function getValueObject(item) {
  switch (item.type) {
    case OPTIONS:
      let value = null;
      item.options.forEach(function (option) {
        if (option.value == item.value) {
          value = option;
          return false;
        }
      });
      return value;
    case CHECK:
    case TEXT:
    case LIST_TYPE:
    default:
      return item;
  }
}
